module.exports = __webpack_public_path__ + "imgs/b99c7664631c1308c84ba999644729a5.jpg";